import Icon from '../components/Icon.vue'

Icon.register({
  igloo: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M320 33.9v126.1h-271.4c51.6-77.2 139.6-128 239.4-128 10.8 0 21.5 0.7 32 1.9zM96 192v128h-96c0-46 11.1-89.4 30.3-128h65.7zM352 39.4c72.8 16.5 135.2 60.5 175.4 120.6h-175.4v-120.6zM480 320v-128h65.7c19.2 38.6 30.3 82 30.3 128h-96zM416 384c0-11.1-1.9-21.7-4.5-32h164.5v96c0 17.7-14.3 32-32 32h-128v-96zM448 192v128h-49.8c-22.2-38.1-63-64-110.2-64s-88 25.9-110.2 64h-49.8v-128h320zM0 448v-96h164.5c-2.6 10.3-4.5 20.9-4.5 32v96h-128c-17.7 0-32-14.3-32-32zM288 288c53 0 96 43 96 96v96h-192v-96c0-53 43-96 96-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/igloo.js
// module id = 1428
// module chunks = 0